import { ReportFeatures } from '@hcs/types';

export const MARKET_ANALYSIS_FEATURES = [
  ReportFeatures.MarketAnalysisChart,
  ReportFeatures.DaysOnMarketChart,
  ReportFeatures.MonthsOfSupplyChart,
];
